"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameserviceBuilder = void 0;
const crypto_1 = require("@arkecosystem/crypto");
const enums_1 = require("../enums");
const transactions_1 = require("../transactions");
class NameserviceBuilder extends crypto_1.Transactions.TransactionBuilder {
    constructor() {
        super();
        this.data.version = enums_1.NameServiceTransactionVersion;
        this.data.typeGroup = enums_1.NameServiceTransactionGroup;
        this.data.type = enums_1.NameServiceTransactionTypes.Nameservice;
        this.data.amount = crypto_1.Utils.BigNumber.ZERO;
        this.data.fee = transactions_1.NameserviceTransaction.staticFee();
        this.data.asset = { nameservice: {} };
    }
    Nameservice(nameservice) {
        if (this.data.asset) {
            this.data.asset.nameservice = nameservice;
        }
        return this;
    }
    getStruct() {
        const struct = super.getStruct();
        struct.amount = this.data.amount;
        struct.asset = this.data.asset;
        struct.vendorField = this.data.vendorField;
        return struct;
    }
    instance() {
        return this;
    }
}
exports.NameserviceBuilder = NameserviceBuilder;
//# sourceMappingURL=nameservice.js.map